import PropTypes from 'prop-types';

const leaf = PropTypes.shape({
  text: PropTypes.string,
});

export const LeafPropTypes = { leaf };
